import React, { Component } from "react";
import {Row, Col, container, Table} from "react-bootstrap";
import ReactPlayer from "react-player";
import './audioplay.css';


import ExternalLayout from "../../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../../customComponents/RenderPage/RenderPage";
import Strip from "../../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../../customComponents/SEO/SEOComponent";
import PropTypes from "prop-types";


// import Male Audio Samples
import audiof1 from "../../../assets/sampleDatasets/KannadaFemale/Kannada_book_f.wav";
import audiof2 from "../../../assets/sampleDatasets/KannadaFemale/Kannada_education_f.wav";
import audiof3 from "../../../assets/sampleDatasets/KannadaFemale/Kannada_weather_f.wav";


function Kannada_Female(){
    return( 
    <div className="container">
        <table>
            {/* Table Heading */}
            <thead>
            <tr>
                <th className="headTable">Audio</th>
                <th className="headTable">Text</th>
            </tr>
            </thead>
            <tbody>
            <tr> {/* Table Row Sample 1 */}
                <td className="tableEvenRow"><ReactPlayer   
                        url={audiof1}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing ">ಅಧ್ಯಾಯ- 3 ಅನ್ಯರಾಷ್ಟ್ರಗಳೊಂದಿಗೆ ಭಾರತದ ಸಂಬಂಧ ಈ ಅಧ್ಯಾಯದಲ್ಲಿ ಕೆಳಗಿನ ಅಂಶಗಳನ್ನು ತಿಳಿಯುತ್ತೇವೆ.</p></td>
            </tr>
            <tr> {/* Table Row Sample 2 */}
                    <td className="tableOddRow"><ReactPlayer   
                        url={audiof2}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableOddRow"><p className="p-medium-line-spacing">ಇಲ್ಲಿ ಜಲ್ ಜೀರಾ ಮಸಾಲ, ಫಾಂಟಾ ಮಸಾಲ, ಸ್ರ್ಕೈಬ್ ಮಸಾಲ, ಲಿಮ್ಕಾಮಸಾಲ, ಮಾಜ್ಹಾ ಮಸಾಲ, ಆಲ್ ಮಿಕ್ಸ್ ಮಸಾಲ ದೊರೆಯುತ್ತದೆ.</p></td>
            </tr>
            <tr> {/* Table Row Sample 3 */}
                    <td className="tableEvenRow"><ReactPlayer   
                        url={audiof3}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">ಈ ಹಿಂದೆ ಅಮೀರ್ ಖಾನ್ ಅವರ 'ತಲಾಶ್' ಚಿತ್ರವನ್ನು ನಿರ್ದೇಶನ ಮಾಡಿದ್ದ ರೀಮಾ ಕಾಗ್ಟಿ ಈಗ 'ಗೋಲ್ಡ್' ಸಿನಿಮಾ ಮಾಡಿದ್ದಾರೆ. </p></td>
            </tr>
            </tbody>
        </table>


    </div>

    );
}

const Sample_Kannada_Female = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
            <RenderPage
                id="tst-landing"
                className={`render px-0 ${props.isClassName ? 'render-page ' : 'min-height-auto'}`}
                containerType="container-fluid"
            > 
                <SEOComponent
                    title="SampleKannadaFemale"
                    keywords="Speech Recognition, respin, SPIRE LAB, Navana"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/SampleKannadaFemale" />
                   
                    <Strip
                        id="tst-SampleDatasets"
                        className="strip strip-no-padding px-20"
                        containerType="container"
                    >
                   

                    <div className="mx-0  pt-5">  
                        <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Sample Kannada Female Audio</h5>
                            <div className="mx-0 mb-5 pb-5">
                                <Kannada_Female />
                            </div>
                    </div>

</Strip>
</RenderPage>
</ExternalLayout>
);
};

export default Sample_Kannada_Female;